const ArchiveBoxIcon = (props) => (
<svg width="14" height="12" viewBox="0 0 14 12" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
<path d="M1.33333 0H12L13.3333 2.66667V11.3333C13.3333 11.5101 13.2631 11.6797 13.1381 11.8047C13.013 11.9298 12.8435 12 12.6667 12H0.666667C0.489856 12 0.320286 11.9298 0.195262 11.8047C0.0702379 11.6797 0 11.5101 0 11.3333V2.66933L1.33333 0ZM12 4H1.33333V10.6667H12V4ZM11.8427 2.66667L11.176 1.33333H2.158L1.49133 2.66667H11.8427ZM7.33333 7.33333H9.33333L6.66667 10L4 7.33333H6V4.66667H7.33333V7.33333Z" fill={props?.fill || "#616778"}/>
</svg>
);

export default ArchiveBoxIcon;
